
























































































































































































































































































































































































































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerSetStatus from '@/components/JobWorkers/JobWorkerSetStatus.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue'
import JobWorkerStatusEnum from '@/models/JobWorkers/JobWorkerStatus';
import JobWorkerOfferStatusEnum from '@/models/JobWorkerOffers/JobWorkerOfferStatus';
import WorkerStatus from '@/components/Workers/Display/WorkerStatus.vue';
import JobWorkerInterviewStatus from '@/components/JobWorkerInterviews/Display/JobWorkerInterviewStatus.vue';
import JobWorkerInterviewWorkerConfirmationStatus from '@/components/JobWorkerInterviews/Display/JobWorkerInterviewWorkerConfirmationStatus.vue';
import JobWorkerInterviewContactConfirmationStatus from '@/components/JobWorkerInterviews/Display/JobWorkerInterviewContactConfirmationStatus.vue';
import JobWorkerOfferWorkerAcceptanceStatus from '@/components/JobWorkerOffers/Display/JobWorkerOfferWorkerAcceptanceStatus.vue';
import JobWorkerOfferContactConfirmationStatus from '@/components/JobWorkerOffers/Display/JobWorkerOfferContactConfirmationStatus.vue';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import JobWorkerInterviewCreate from '@/components/JobWorkerInterviews/JobWorkerInterviewCreate.vue';
import JobWorkerInterviewDetailsEdit from '@/components/JobWorkerInterviews/JobWorkerInterviewDetailsEdit.vue';
import JobWorkerInterviewFeedbackEdit from '@/components/JobWorkerInterviews/JobWorkerInterviewFeedbackEdit.vue';
import JobWorkerInterviewType from '@/models/JobWorkerInterviews/JobWorkerInterviewType';
import InPersonInterviewAddressType from '@/models/JobWorkerInterviews/InPersonInterviewAddressType';
import JobWorkerInterviewStatusSet from '@/components/JobWorkerInterviews/JobWorkerInterviewStatusSet.vue';
import JobWorkerInterviewStatusEnum from '@/models/JobWorkerInterviews/JobWorkerInterviewStatus';
import JobWorkerOfferStatus from '@/components/JobWorkerOffers/Display/JobWorkerOfferStatus.vue';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import JobWorkerOfferCreate from '@/components/JobWorkerOffers/JobWorkerOfferCreate.vue';
import JobWorkerOfferEdit from '@/components/JobWorkerOffers/JobWorkerOfferEdit.vue';
import JobWorkerPlacementEdit from '@/components/JobWorkerOffers/JobWorkerPlacementEdit.vue';


import JobWorkerOfferStatusSet from '@/components/JobWorkerOffers/JobWorkerOfferStatusSet.vue'

@Component({
  name: 'JobWorker',
  components: { WorkerStatus, JobWorkerSetStatus, JobWorkerStatus, JobWorkerInterviewStatusSet, JobWorkerInterviewStatus, JobWorkerInterviewWorkerConfirmationStatus, JobWorkerInterviewContactConfirmationStatus, JobWorkerOfferWorkerAcceptanceStatus, JobWorkerOfferContactConfirmationStatus, JobWorkerInterviewCreate, JobWorkerInterviewDetailsEdit, JobWorkerInterviewFeedbackEdit, JobWorkerOfferStatusSet, JobWorkerOfferStatus, JobWorkerOfferCreate, JobWorkerOfferEdit, JobWorkerPlacementEdit }
})
export default class extends GiganautVue {

	jobWorkerStatusEnum = JobWorkerStatusEnum;
	jobWorkerOfferStatusEnum = JobWorkerOfferStatusEnum;
	jobWorkerInterviewTypeEnum = JobWorkerInterviewType;
	jobWorkerInterviewStatusEnum = JobWorkerInterviewStatusEnum;
	inPersonInterviewAddressTypeEnum = InPersonInterviewAddressType;
	page = 1;
	perPage = 8;
	
	@Prop({required: true})
	tab: string;

	tabLocal = '';

	@Prop({required: true})
	parentTab: string;

	@Prop({required: true})
	jobWorker: JobWorkerDto;

	get job() {
		return JobDetailsModule.currentJob;
	}

	async beforeMount() {
		this.tabLocal = this.tab;
	}

	get selectedJobWorkerInterview() {
		if (this.parentTab === "interviewing") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForInterviewingTab;
		} else if (this.parentTab === "offers") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForOffersTab;
		} else if (this.parentTab === "placed") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForPlacedTab;
		} else if (this.parentTab === "rejected") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForRejectedTab;
		}
		return null;
	}

	set selectedJobWorkerInterview(value: JobWorkerInterviewDto) {
		if (this.parentTab === "interviewing") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForInterviewingTab = value;
		} else if (this.parentTab === "offers") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForOffersTab = value;
		} else if (this.parentTab === "placed") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForPlacedTab = value;
		} else if (this.parentTab === "rejected") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerInterviewForRejectedTab = value;
		}
	}

	get showInterviews() {
		return this.jobWorker.status >= JobWorkerStatusEnum.ContactInterested;
	}

	get selectedJobWorkerOffer() {
		if (this.parentTab === "interviewing") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForInterviewingTab;
		} else if (this.parentTab === "offers") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForOffersTab;
		} else if (this.parentTab === "placed") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForPlacedTab;
		} else if (this.parentTab === "rejected") {
			return JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForRejectedTab;
		}
		return null;
	}

	set selectedJobWorkerOffer(value: JobWorkerOfferDto) {
		if (this.parentTab === "interviewing") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForInterviewingTab = value;
		} else if (this.parentTab === "offers") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForOffersTab = value;
		} else if (this.parentTab === "placed") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForPlacedTab = value;
		} else if (this.parentTab === "rejected") {
			JobDetailsModule.jobWorkersVM.selectedJobWorkerOfferForRejectedTab = value;
		}
	}

	get showOffers() {
		return this.jobWorker.status >= JobWorkerStatusEnum.InterviewOne;
	}
	
	get loadingWorker() {
		return false;//return JobDetailsModule.loadingWorker;
	}
}
